import styled from '@emotion/styled';
import {
	ArrowIconLight,
	DownloadIconLight,
	EmailIcon,
	ExternalLinkIconLight,
} from '@/ui';

import { ButtonLabel } from '../button/Button';
import { Color } from '../../../styles/Color';
import { theme } from '../../../styles/theme';
import PhoneIcon from '../../../assets/icons/actions/phone.svg';
import { ICON_GAP_TRANSITION } from '../../../styles/animation/iconGapTransition';
import { RouterLink } from '../link/RouterLink';

interface IQuickLinkProps {
	type:
		| 'email'
		| 'external'
		| 'internal'
		| 'asset'
		| 'phone'
		| 'externalSecondary';
	label: string;
	url: string;
}

const ICON_MAP = {
	email: <EmailIcon />,
	external: <ExternalLinkIconLight />,
	internal: <ArrowIconLight />,
	asset: <DownloadIconLight />,
	phone: <PhoneIcon />,
	externalSecondary: null,
};

export function QuickLink({ type, label, url }: IQuickLinkProps) {
	const icon = ICON_MAP[type];
	const openInNewTab = [
		'external',
		'asset',
		'email',
		'externalSecondary',
	].includes(type);

	return (
		<StyledLink href={url} target={openInNewTab ? '_blank' : undefined}>
			<ButtonLabel aria-label={label}>{label}</ButtonLabel>
			{icon}
		</StyledLink>
	);
}

const StyledLink = styled(RouterLink)`
	display: flex;
	align-items: center;
	text-decoration: none;
	font-weight: 500;
	gap: ${theme.button?.iconSeparator};
	transition: ${`gap ${ICON_GAP_TRANSITION}`};
	margin-top: auto;

	svg {
		path {
			fill: ${Color.PrimaryBlue};
		}
	}

	&:hover {
		color: ${Color.PrimaryBlue};
		gap: 1em;
		padding-right: 1em;
	}
`;
